import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';

export const Confirmation = () => {
  return (
    <Alert
      status="success"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      padding={6}
    >
      <AlertIcon boxSize="40px" mr={0} />
      <AlertTitle mt={4} mb={1} fontSize="lg">
        Instrucciones enviadas
      </AlertTitle>
      <AlertDescription maxWidth="sm">
        Si no has recibido un email con las instrucciones mira la carpeta de
        spam.
      </AlertDescription>
      <AlertDescription maxWidth="sm">
        Aseguráte que has introducido la dirección de correo electrónico
        correcta.
      </AlertDescription>
    </Alert>
  );
};
